const sliderInit = (isUpdate, scope = document) => {
  const root =
    scope && typeof scope.querySelectorAll === "function" ? scope : document;
  const mediaLists = root.querySelectorAll(".js-media-list");

  if (mediaLists && mediaLists.length > 0) {
    mediaLists.forEach((elem) => {
      const sliderType = elem.dataset.sliderType;
      const productRoot = elem.closest(".product") || elem.closest("section");
      const navRoot = productRoot?.querySelector(".product__slider-nav");
      const nextEl = navRoot?.querySelector(".swiper-button-next") || null;
      const prevEl = navRoot?.querySelector(".swiper-button-prev") || null;
      const paginationEl =
        productRoot?.querySelector(".product__pagination") || null;
      const sublistEl =
        elem.nextElementSibling?.querySelector(".js-media-sublist") ||
        productRoot?.querySelector(".js-media-sublist");

      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 500,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl,
          type: "bullets",
          clickable: true,
        },
        thumbs: {
          swiper: sublistEl?.swiper || "",
        },
        on: {
          afterInit: function (swiper) {
            const mediaToggles = productRoot?.querySelectorAll(
              ".product__media-toggle"
            );
            mediaToggles?.forEach((mediaToggle, index) => {
              mediaToggle.addEventListener("click", () => {
                const popupSliderEl =
                  productRoot?.querySelector(".js-popup-slider");
                if (popupSliderEl?.swiper) {
                  popupSliderEl.swiper.slideTo(index);
                }
              });
            });
          },
          slideChangeTransitionStart: function () {
            if (sublistEl?.swiper) {
              sublistEl.swiper.slideTo(this.activeIndex);
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            const popupSliderEl =
              productRoot?.querySelector(".js-popup-slider");
            if (popupSliderEl?.swiper) {
              popupSliderEl.swiper.slideTo(this.activeIndex);
            }
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 400);
      }
    });
  }
};

const subSliderInit = (isUpdate, scope = document) => {
  const root =
    scope && typeof scope.querySelectorAll === "function" ? scope : document;
  const mediaSublists = root.querySelectorAll(".js-media-sublist");

  if (mediaSublists && mediaSublists.length > 0) {
    mediaSublists.forEach((elem, index) => {
      if (index >= 1) return;

      const productRoot = elem.closest(".product") || elem.closest("section");

      let subSlider = new Swiper(elem, {
        slidesPerView: 7,
        direction: "horizontal",
        freeMode: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },

        breakpoints: {
          576: {
            direction: "vertical",
            slidesPerView: "auto",
            autoHeight: true,
            spaceBetween: 0,
          },
        },
      });

      const sliderResizeObserve = new ResizeObserver((entries) => {
        const [entry] = entries;
        setTimeout(() => {
          const sliders = root.querySelectorAll(
            ".js-media-list .product__media"
          );
          const thumbs = root.querySelectorAll(".product__media-sublist");
          if (sliders.length > 0 && thumbs.length > 0) {
            if (index >= 0 && index < sliders.length) {
              const sliderHeight =
                sliders[index].getBoundingClientRect().height;
              thumbs[index].style.maxHeight = `${sliderHeight - 1}px`;
            }
          }
        }, 0);
      });

      if (productRoot) sliderResizeObserve.observe(productRoot);

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

function optimizingVisibleSliderElements(sliderElement, sliderItemClass) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.visibility = "visible";
        } else {
          entry.target.style.visibility = "hidden";
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    }
  );

  sliderElement.querySelectorAll(sliderItemClass).forEach((slide) => {
    observer.observe(slide);
  });
}

const quickAddsliderInit = (isUpdate, scope = document) => {
  const root =
    scope && typeof scope.querySelectorAll === "function" ? scope : document;
  const mediaLists = root.querySelectorAll(".js-media-list");

  if (mediaLists && mediaLists.length > 0) {
    mediaLists.forEach((elem) => {
      const productRoot =
        elem.closest(".product") || elem.closest("quick-add-modal");
      const navRoot = productRoot?.querySelector(".product__slider-nav");
      const nextEl = navRoot?.querySelector(".swiper-button-next") || null;
      const prevEl = navRoot?.querySelector(".swiper-button-prev") || null;
      const paginationEl =
        productRoot?.querySelector(".product__pagination") || null;

      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        direction: "horizontal",
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl,
          type: "bullets",
          clickable: true,
        },
        on: {
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const popupSliderInit = (isUpdate) => {
  if (document.querySelector(".js-popup-slider")) {
    const thumbs = document.querySelector(".js-popup-sublist")?.swiper;

    let popupSlider = new Swiper(document.querySelector(".js-popup-slider"), {
      slidesPerView: 1,
      spaceBetween: 4,
      speed: 500,
      zoom: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      spaceBetween: 8,
      navigation: {
        nextEl: ".product-media-modal .swiper-button-next",
        prevEl: ".product-media-modal .swiper-button-prev",
      },
      pagination: {
        el: ".product-media-modal .product__pagination",
        type: "fraction",
      },
      thumbs: {
        swiper: thumbs,
      },
      on: {
        click: function (e) {
          if (this.zoom.scale === 1) {
            this.zoom.in();
          } else {
            this.zoom.out();
          }
        },
        afterInit: function () {
          if (
            document.querySelector(
              ".product__outer--static-multicolumns-aside"
            ) ||
            document.querySelector(".product__outer--static-column-aside")
          ) {
            document
              .querySelectorAll(".product__media-list .product__media-toggle")
              .forEach((elem, index) => {
                elem.addEventListener("click", (e) => {
                  if (
                    document.querySelector(".js-popup-slider") &&
                    document.querySelector(".js-popup-slider").swiper
                  ) {
                    document
                      .querySelector(".js-popup-slider")
                      .swiper.slideTo(index);
                  }
                });
              });
          }
        },
        slideChangeTransitionStart: function () {
          if (document.querySelector(".js-popup-sublist")) {
            document
              .querySelector(".js-popup-sublist")
              .swiper.slideTo(
                document.querySelector(".js-popup-slider").swiper.activeIndex
              );
          }
        },

        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          document
            .querySelector(".product-media-modal__content")
            .classList.remove("zoom");
        },
        touchMove: function () {
          document
            .querySelector(".product-media-modal__content")
            .classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });

    if (isUpdate) {
      setTimeout(function () {
        popupSlider.update();
      }, 800);
    }
  }
};

const popupSubSliderInit = (isUpdate) => {
  if (document.querySelector(".js-popup-sublist")) {
    let popupSubSlider = new Swiper(
      document.querySelector(".js-popup-sublist"),
      {
        slidesPerView: "auto",
        freeMode: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: true,
        direction: "horizontal",
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        breakpoints: {
          576: {
            direction: "vertical",
            slidesPerView: "auto",
            autoHeight: true,
            spaceBetween: 0,
          },
        },
        on: {
          touchEnd(s) {
            let range = 5;
            let diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY;

            if (diff < range && diff > -range) {
              s.allowClick = true;
            }
          },

          click(swiper) {
            const main = document.querySelector(".js-popup-slider")?.swiper;
            if (main) {
              main.slideTo(swiper.clickedIndex);
            }
          },
        },
      }
    );

    if (isUpdate) {
      setTimeout(function () {
        popupSubSlider.update();
      }, 800);
    }
  }
};

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((el) => el.offsetParent !== null);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document
    .querySelectorAll(".product__media-list .js-youtube")
    .forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
  document
    .querySelectorAll(".product__media-list .js-vimeo")
    .forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
  document
    .querySelectorAll(".product__media-list video")
    .forEach((video) => video.pause());
  document
    .querySelectorAll(".product__media-list product-model")
    .forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.isCartItem = Boolean(this.closest(".cart-item"));

    this.querySelectorAll("button").forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    var eventList = ["paste", "input"];

    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const value = e.currentTarget.value;
        const numberRegex = this.isCartItem ? /^\d*$/ : /^0*?[1-9]\d*$/;

        if (numberRegex.test(value) || value === "") {
        } else {
          e.currentTarget.value = 1;
        }

        this.setMinimumDisable();
      });
    }

    this.input.addEventListener("focusout", function (e) {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }
    });
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add("disabled");
    } else {
      this.querySelector('button[name="minus"]').classList.remove("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(func, delay) {
  let lastTime = 0;

  return function (...args) {
    const now = Date.now();

    if (now - lastTime >= delay) {
      func.apply(this, args);
      lastTime = now;
    }
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt?.getAttribute("data-provinces");
    var provinces = JSON.parse(raw || "{}");

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".toggle-scheme-button") === button) return;
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector("button.header__localization-button") === button)
        return;
      if (
        this.querySelector("button.header__localization-lang-button") === button
      )
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      this.header =
        this.header || document.querySelector(".shopify-section-header");
      const main = document.querySelector("main");
      if (
        main
          .querySelectorAll(".shopify-section")[0]
          ?.classList.contains("section--has-overlay") &&
        !this.header.classList.contains("animate")
      ) {
        this.header.classList.add("color-background-1", "color-background-3");
      }
      if (
        this.header.classList.contains("color-background-1") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.add("color-background-3");
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#SearchModal-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.querySelector("#search-modal-close").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    if (document.querySelector("#search-icon-open") != null) {
      const cartLink = document.querySelector("#search-icon-open");
      if (cartLink != null) {
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
        cartLink.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("search-modal");
        const focusElement =
          this.querySelector('.header__search input:not([type="hidden"])') ||
          this.querySelector(".search__main") ||
          this.querySelector(".search__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("search-modal", SearchModal);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    const modalApplyClose = this.querySelector("#ModalApplyClose");
    if (modalApplyClose) {
      modalApplyClose.addEventListener("click", this.hide.bind(this, false));
    }

    this.addEventListener("keyup", (event) => {
      if (event.code && event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    this.addEventListener(
      "transitionend",
      () => {
        trapFocus(this, this.querySelector(".modal-close-button"));
      },
      { once: true }
    );
    if (opener.dataset.type == "notify") {
      this.setCorrectValues(opener.dataset.id);
    }
  }

  setCorrectValues(id) {
    const hiddenInput = document.querySelector(`#${id}-ContactForm-options`);
    const form = document.querySelector(
      `#${id}-notify_popup .notify_subscription`
    );

    function getSelectedOptions() {
      const options = [];
      const radios = document.querySelectorAll(
        `#${id}-product-form input[type="radio"]:checked`
      );

      radios.forEach((radio) => {
        const nameParts = radio.name.split("-");
        const optionName = nameParts[0];
        const optionValue = radio.value;
        options.push(`${optionName}: ${optionValue}`);
      });

      return options.join(", ");
    }

    if (form) {
      form.addEventListener("submit", function () {
        hiddenInput.value = getSelectedOptions();
      });
    }
  }

  hide(isProductPage = false) {
    let isOpen = false;

    this.removeAttribute("open");
    this.classList.add("hiding");

    if (!isProductPage) {
      removeTrapFocus(this.openedBy);
    }
    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    let CartDrawerNote = document.getElementById("CartDrawer-Note");
    let CartDrawerNoteAppla = document.getElementById("CartDrawer-Note-Applay");

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));

      if (CartDrawerNote && CartDrawerNoteAppla) {
        if (CartDrawerNote.value.trim() !== "") {
          CartDrawerNoteAppla.classList.add("show");
        } else {
          CartDrawerNoteAppla.classList.remove("show");
        }
      }
    }

    const images = document.querySelector(".product-media-modal__content");

    if (images) {
      images.classList.remove("zoom");
    }

    setTimeout(() => this.classList.remove("hiding"), 700);
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;

    const syncProductModalSlide = (modal, openerButton, openerElement) => {
      if (!modal || !modal.classList.contains("product-media-modal")) return;

      const popupSlider = modal.querySelector(".js-popup-slider")?.swiper;
      if (!popupSlider) return;

      let targetMediaId = openerButton?.dataset?.mediaId || null;

      if (!targetMediaId) {
        const openerMediaScope = openerElement.closest("[data-media-id]");
        const scopedMediaId = openerMediaScope?.dataset?.mediaId;
        if (scopedMediaId) {
          targetMediaId = scopedMediaId.split("-").pop();
        }
      }

      if (!targetMediaId) {
        const productRoot = openerElement.closest(".product");
        const mainSlider = productRoot?.querySelector(".js-media-list")?.swiper;
        const activeMainSlide = mainSlider?.slides?.[mainSlider.activeIndex];
        const activeMediaId = activeMainSlide?.dataset?.mediaId;

        if (activeMediaId) {
          targetMediaId = activeMediaId.split("-").pop();
        }
      }

      if (!targetMediaId) return;

      const targetIndex = popupSlider.slides.findIndex((slide) => {
        if (slide.dataset?.mediaModalId?.endsWith(`-${targetMediaId}`)) {
          return true;
        }

        return !!slide.querySelector(`[data-media-id="${targetMediaId}"]`);
      });

      if (targetIndex < 0) return;

      if (popupSlider.activeIndex !== targetIndex) {
        popupSlider.slideTo(targetIndex, 0, false);
      }

      const popupThumbs = modal.querySelector(".js-popup-sublist")?.swiper;
      if (popupThumbs && popupThumbs.activeIndex !== targetIndex) {
        popupThumbs.slideTo(targetIndex, 0, false);
      }
    };

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) {
        syncProductModalSlide(modal, button, this);
        modal.show(button);
      }
    });

    if (this.closest(".product-popup") != null) {
      this.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) {
          syncProductModalSlide(modal, button, this);
          modal.show(button);
        }
      });
    }
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener("click", this.loadContent.bind(this));
    }

    if (this.dataset.autoplay === "true") {
      this.loadContent();
    }
  }

  loadContent() {
    const parentEl =
      this.closest(".product__media") || this.closest(".product-media-modal");
    pauseAllMedia(parentEl);

    if (this.getAttribute("loaded")) return;

    const template = this.querySelector("template");
    if (!template) return;

    const content = document.createElement("div");
    content.appendChild(template.content.firstElementChild.cloneNode(true));
    this.setAttribute("loaded", true);

    const media = content.querySelector("video, model-viewer, iframe");
    if (!media) return;

    const deferredElement = this.appendChild(media);
    deferredElement.focus();

    if (["VIDEO", "IFRAME"].includes(deferredElement.nodeName)) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            let shouldAutoplay = false;
            const parentSlide = entry.target.closest(".swiper-slide");
            if (parentSlide) {
              if (parentSlide.classList.contains("swiper-slide-active")) {
                shouldAutoplay = true;
              }
            } else {
              if (entry.intersectionRatio > 0.7) {
                shouldAutoplay = true;
              }
            }

            if (shouldAutoplay) {
              if (
                (this.dataset.autoplay === "true" &&
                  !this.closest("product-modal")) ||
                (this.dataset.autoplay === "true" &&
                  this.closest("product-modal")?.hasAttribute("open"))
              ) {
                pauseAllMedia(parentEl, this);

                if (entry.target.nodeName === "VIDEO") {
                  entry.target.play()?.catch((error) => {
                    console.error("Error playing video:", error);
                  });
                } else if (
                  entry.target.nodeName === "IFRAME" &&
                  entry.target.contentWindow
                ) {
                  if (entry.target.classList.contains("js-youtube")) {
                    entry.target.contentWindow.postMessage(
                      '{"event":"command","func":"playVideo","args":""}',
                      "*"
                    );
                  } else {
                    entry.target.contentWindow.postMessage(
                      '{"method":"play"}',
                      "*"
                    );
                  }
                }
              }
            } else {
              if (entry.target.nodeName === "VIDEO") {
                entry.target.pause();
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"pause"}',
                    "*"
                  );
                }
              }
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      videoObserver.observe(deferredElement);
    }

    const modelViewer = this.closest(".swiper-slide-active")?.querySelector(
      "model-viewer"
    );
    if (
      modelViewer &&
      !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
    ) {
      const swiper = this.closest(".swiper")?.swiper;
      if (swiper) {
        swiper.params.noSwiping = true;
        swiper.params.noSwipingClass = "swiper-slide";
      }
    }

    this.querySelectorAll(
      "video, .shopify-model-viewer-ui__controls-overlay"
    ).forEach((el) => {
      if (this.getAttribute("loaded") === "true") {
        el.addEventListener("click", (event) => {
          if (el.nodeName === "VIDEO") {
            event.preventDefault();
            if (el.paused) {
              el.play();
            } else {
              el.pause();
            }
          } else {
            pauseAllMedia(parentEl, this);
          }
        });
      }
    });
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const clickedElement =
      event.target.closest("[data-product-url]") || event.target;
    this.combinedProductURL = clickedElement.dataset?.productUrl || null;

    const combinedProductURL = event.target.dataset?.productUrl;

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.dataset?.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.updateMedia(mediaId);
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        const checkedInput = Array.from(
          fieldset.querySelectorAll("input")
        ).find((radio) => radio.checked);
        return checkedInput ? checkedInput.value : null;
      }).filter((value) => value != null)
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId = null) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const scope = this.getUpdateScope();
    const isQuickView = scope !== document;

    const targetMediaId =
      mediaId ||
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`;

    /**
     * ------------------------------------------------
     * Main sliders
     * ------------------------------------------------
     */
    const swiperWrappers = isQuickView
      ? scope.querySelectorAll(
          ".product__media-wrapper, .global-variant-slider"
        )
      : document.querySelectorAll(
          ".product__media-wrapper, .global-variant-slider"
        );

    swiperWrappers.forEach((elem) => {
      if (isQuickView) {
        if (!elem.closest("quick-add-modal")) return;
      } else if (elem.closest("quick-add-modal")) {
        return;
      }

      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const parent = newMedia.parentElement;

      const mediaList = elem.querySelector(
        ".js-media-list, .global-variant-js-media-list"
      );

      /**
       * Swiper layouts
       */
      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        // fallback
        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        /**
         * Non-swiper layouts
         */
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }

      /**
       * stacked / stacked_previews support
       */
      const stackedList =
        elem.querySelector(
          ".product__media-list[data-desktop-type='stacked_previews']"
        ) ||
        elem.querySelector(".product__media-list[data-desktop-type='stacked']");

      if (stackedList && window.innerWidth >= 990) {
        const targetItem = stackedList.querySelector(
          `[data-media-id="${targetMediaId}"]`
        );

        if (targetItem) {
          const offset =
            targetItem.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: offset - 100,
            behavior: "smooth",
          });
        }
      }
    });

    /**
     * ------------------------------------------------
     * Quick view
     * ------------------------------------------------
     */
    const swiperWrappersQuickView = isQuickView
      ? scope.querySelectorAll(".quick-product__media-list")
      : document.querySelectorAll(".quick-product__media-list");

    swiperWrappersQuickView.forEach((elem) => {
      if (isQuickView && !elem.closest("quick-add-modal")) return;
      if (!isQuickView && elem.closest("quick-add-modal")) return;

      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const parent = newMedia.parentElement;

      const mediaList = elem.querySelector(".quick-js-media-list");

      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }
    });
  }

  updateURL() {
    if (this.getUpdateScope() !== document) return;
    if (this.dataset.updateUrl === "false") return;
    let basePath =
      this.combinedProductURL || this.dataset.url || window.location.pathname;

    if (basePath.includes("?")) {
      basePath = basePath.split("?")[0];
    }

    const newUrl = this.currentVariant
      ? `${basePath}?variant=${this.currentVariant.id}`
      : basePath;

    window.history.replaceState({}, "", newUrl);
  }

  updateVariantInput() {
    const scope = this.getUpdateScope();
    const productForms = scope.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-installment, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    if (
      typeof publish === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined" &&
      PUB_SUB_EVENTS.variantChange
    ) {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.dataset.section,
          variant: this.currentVariant,
        },
      });
    }
  }

  updateVariantStatuses() {
    // For high-variant products the local JSON pool ([data-all-variants-no-high])
    // only contains the first 250 of potentially 300+ variants. Running availability
    // logic against that incomplete set marks valid option2/option3 values as
    // disabled. The fetch path (renderProductInfo → updatePickerInnerHtml) replaces
    // the fieldsets with server-rendered HTML that has correct disabled states, so
    // skip the JS-side update entirely for high-variant products.
    if (this.dataset.isHighVariantProduct === "true") return;

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const scope = this.getUpdateScope();
    const pickUpAvailability = scope.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    const scope = this.getUpdateScope();
    const productForms = scope.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-installment, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector('[name="add"] > .button-wrapper-anim > span') ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text && addButtonText) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    const scope = this.getUpdateScope();
    const productForms = scope.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const scope = this.getUpdateScope();
    const price = this.getScopedElementById(
      scope,
      `price-${this.dataset.section}`
    );
    const priceSticky = this.getScopedElementById(
      scope,
      `price-sticky-${this.dataset.section}`
    );
    const inventory = this.getScopedElementById(
      scope,
      `Inventory-${this.dataset.section}`
    );
    const pickerInventory = this.getScopedElementById(
      scope,
      `PickerInventory-${this.dataset.section}`
    );
    const sku = this.getScopedElementById(scope, `Sku-${this.dataset.section}`);
    const colorNameDestinations = scope.querySelectorAll(
      `[id^="ColorName-${this.dataset.section}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (pickerInventory) pickerInventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }

  getVariantPickerElement(scope, sectionId) {
    if (!scope || !sectionId) return null;

    return (
      scope.getElementById?.(`variant-picker-${sectionId}`) ||
      scope.getElementById?.(`variant-radios-${sectionId}`) ||
      scope.querySelector?.(`#variant-picker-${sectionId}`) ||
      scope.querySelector?.(`#variant-radios-${sectionId}`)
    );
  }

  getUpdateScope() {
    return this.closest("quick-add-modal") || document;
  }

  getScopedElementById(scope, id) {
    if (!scope || !id) return null;
    if (typeof scope.getElementById === "function") {
      return scope.getElementById(id);
    }
    return scope.querySelector(`#${id}`);
  }

  remapMarkupToSection(markup, sourceSectionId, currentSectionId) {
    if (!markup || !sourceSectionId || !currentSectionId) return markup;
    if (sourceSectionId === currentSectionId) return markup;
    return markup.replaceAll(sourceSectionId, currentSectionId);
  }

  reinitializeDropdownSelect() {
    if (typeof window.initProductDropdownSelect === "function") {
      window.initProductDropdownSelect(this.getUpdateScope());
    }
  }

  updateElementsAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const destinationScope = this.getUpdateScope();
    const isQuickView = destinationScope !== document;

    // =================================================================
    // 1. UPDATE BASE URL & CLEAR CACHED STATE OBJECTS
    // =================================================================
    const sourceVariantPicker = html.querySelector(
      "variant-selects, variant-radios"
    );
    if (sourceVariantPicker) {
      if (sourceVariantPicker.dataset.url) {
        this.dataset.url = sourceVariantPicker.dataset.url;
      }
      if (sourceVariantPicker.dataset.isHighVariantProduct) {
        this.dataset.isHighVariantProduct =
          sourceVariantPicker.dataset.isHighVariantProduct;
      }
    }

    // Purge the master array cache so it's forced to look at the new product JSON
    this.variantData = null;

    // =================================================================
    // 2. SYNCHRONIZE HIDDEN VARIANT JSON MARKUP POOLS & FIX VISIBILITY BUG
    // =================================================================
    const sourceScriptNoHigh = html.querySelector(
      "[data-all-variants-no-high]"
    );
    const destScriptNoHigh = this.querySelector("[data-all-variants-no-high]");
    if (sourceScriptNoHigh && destScriptNoHigh) {
      destScriptNoHigh.textContent = sourceScriptNoHigh.textContent;
    }

    const sourceScriptSelected = html.querySelector("[data-selected-variant]");
    const destScriptSelected = this.querySelector("[data-selected-variant]");
    if (sourceScriptSelected && destScriptSelected) {
      destScriptSelected.textContent = sourceScriptSelected.textContent;

      // FIXES THE 'visibility-hidden' BUG:
      // Instantly inject the correct selected variant object into the component state
      try {
        this.currentVariant = JSON.parse(sourceScriptSelected.textContent);
      } catch (e) {
        this.currentVariant = null;
      }
    }

    // =================================================================
    // 3. OVERWRITE INPUT CONTROLS MARKUP COMPLETELY
    // =================================================================
    if (sourceVariantPicker) {
      const sourceFieldsets = sourceVariantPicker.querySelectorAll("fieldset");
      const destFieldsets = this.querySelectorAll("fieldset");

      if (sourceFieldsets.length > 0 && destFieldsets.length > 0) {
        sourceFieldsets.forEach((sourceFieldset, index) => {
          if (destFieldsets[index]) {
            if (
              destFieldsets[index].classList.contains(
                "product-form__controls--dropdown"
              )
            ) {
              destFieldsets[index].removeAttribute("data-initialized");
            }
            const quickViewModal = this.closest("quick-add-modal");
            destFieldsets[index].innerHTML = quickViewModal
              ? this.remapMarkupToSection(
                  sourceFieldset.innerHTML,
                  sourceSectionId,
                  currentSectionId
                )
              : sourceFieldset.innerHTML;
            if (sourceFieldset.className)
              destFieldsets[index].className = sourceFieldset.className;
          }
        });
      } else {
        const quickViewModal = this.closest("quick-add-modal");
        this.innerHTML = quickViewModal
          ? this.remapMarkupToSection(
              sourceVariantPicker.innerHTML,
              sourceSectionId,
              currentSectionId
            )
          : sourceVariantPicker.innerHTML;
      }

      this.reinitializeDropdownSelect();
    }

    // =================================================================
    // 4. RESET MASTER FORM REFERENCE FIELD
    // =================================================================
    const productFormInput = this.closest(".product-section")?.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    const sourceProductFormInput = html.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (productFormInput && sourceProductFormInput) {
      productFormInput.value = sourceProductFormInput.value;
    }

    // Keep recipient form in sync with the currently selected product.
    const sourceProductForm = html.getElementById(
      `product-form-${sourceSectionId}`
    );
    const destinationProductForm = document.getElementById(
      `product-form-${currentSectionId}`
    );
    const scopedDestinationProductForm = this.getScopedElementById(
      destinationScope,
      `product-form-${currentSectionId}`
    );
    if (sourceProductForm && scopedDestinationProductForm) {
      const sourceProductFormWrapper =
        sourceProductForm.closest("product-form");
      const destinationProductFormWrapper =
        scopedDestinationProductForm.closest("product-form");

      if (sourceProductFormWrapper && destinationProductFormWrapper) {
        const hideErrorsValue =
          sourceProductFormWrapper.getAttribute("data-hide-errors");

        if (hideErrorsValue !== null) {
          destinationProductFormWrapper.setAttribute(
            "data-hide-errors",
            hideErrorsValue
          );
        } else {
          destinationProductFormWrapper.removeAttribute("data-hide-errors");
        }
      }

      const sourceRecipientForm =
        sourceProductForm.querySelector("recipient-form");
      const destinationRecipientForm =
        scopedDestinationProductForm.querySelector("recipient-form");

      if (sourceRecipientForm) {
        if (!customElements.get("recipient-form")) {
          const recipientScriptSrc = sourceProductForm
            .querySelector('script[src*="recipient-form.js"]')
            ?.getAttribute("src");
          const scriptAlreadyLoaded = recipientScriptSrc
            ? [...document.scripts].some(
                (script) => script.src === recipientScriptSrc
              )
            : false;

          if (recipientScriptSrc && !scriptAlreadyLoaded) {
            const recipientScript = document.createElement("script");
            recipientScript.src = recipientScriptSrc;
            recipientScript.defer = true;
            document.head.appendChild(recipientScript);
          }
        }

        const nextRecipientForm = sourceRecipientForm.cloneNode(true);
        if (destinationRecipientForm) {
          destinationRecipientForm.replaceWith(nextRecipientForm);
        } else {
          const productFormButtons = destinationProductForm.querySelector(
            ".product-form__buttons"
          );

          if (productFormButtons) {
            productFormButtons.insertAdjacentElement(
              "beforebegin",
              nextRecipientForm
            );
          } else {
            scopedDestinationProductForm.appendChild(nextRecipientForm);
          }
        }
      } else if (destinationRecipientForm) {
        destinationRecipientForm.remove();
      }
    }

    // title — scope to ProductInfo container so we only update the correct section.
    // In Quick View, removeDOMElements() moves .product__title__wrapper out of
    // ProductInfo-* into .quick-add-info, so we fall back to destinationScope
    // when the scoped lookup finds the container but not the title inside it.
    const sourceTitleInfo = html.getElementById(
      `ProductInfo-${sourceSectionId}`
    );
    const destinationTitleInfo = this.getScopedElementById(
      destinationScope,
      `ProductInfo-${currentSectionId}`
    );
    const titleSource = (sourceTitleInfo || html).querySelector(
      ".product__title, .product-single__title"
    );
    const titleDestination =
      destinationTitleInfo?.querySelector(
        ".product__title, .product-single__title"
      ) ||
      destinationScope.querySelector(".product__title, .product-single__title");
    if (titleSource && titleDestination) {
      titleDestination.innerHTML = titleSource.innerHTML;
    }

    // informational blocks (badges/description-like content)
    // Keep these in sync with fetched product markup to avoid stale data
    // when switching products via Combined Listings.
    const sourceInfoContainers = html.querySelectorAll(
      `#ProductInfo-${sourceSectionId}`
    );
    const destinationInfoContainers = destinationScope.querySelectorAll(
      `#ProductInfo-${currentSectionId}`
    );
    const sourceInfoContainersArray = Array.from(sourceInfoContainers);

    const syncQuickViewCustomBadgesInTitle = () => {
      if (!isQuickView) return;

      const destinationTitleWrapper =
        destinationScope.querySelector(
          ".quick-add-info .product__title__wrapper"
        ) || destinationScope.querySelector(".product__title__wrapper");
      if (!destinationTitleWrapper) return;

      const sourceCustomBadge = html.querySelector(
        `#ProductInfo-${sourceSectionId} .product__custom-badges`
      );

      destinationTitleWrapper
        .querySelectorAll(":scope > .product__custom-badges")
        .forEach((node) => node.remove());

      if (sourceCustomBadge) {
        destinationTitleWrapper.appendChild(sourceCustomBadge.cloneNode(true));
      }
    };

    const removeQuickViewRedundantCustomBadges = () => {
      if (!isQuickView) return;

      destinationScope
        .querySelectorAll(
          `#ProductInfo-${currentSectionId} .product__custom-badges`
        )
        .forEach((badge) => {
          if (!badge.closest(".product__title__wrapper")) {
            badge.remove();
          }
        });
    };

    const syncInfoSelector = (
      sourceContainer,
      destinationContainer,
      selector,
      insertBeforeSelector = null
    ) => {
      if (!sourceContainer || !destinationContainer) return;

      const sourceNodes = sourceContainer.querySelectorAll(selector);
      const destinationNodes = destinationContainer.querySelectorAll(selector);

      // Remove stale destination nodes if source no longer has this block.
      if (!sourceNodes.length && destinationNodes.length) {
        destinationNodes.forEach((node) => node.remove());
        return;
      }

      // If source has nodes but destination does not, create from source.
      if (sourceNodes.length && !destinationNodes.length) {
        const destinationMainContent = destinationContainer.querySelector(
          ".product__info-main_content"
        );

        if (destinationMainContent) {
          const preferredInsertBefore = insertBeforeSelector
            ? destinationMainContent.querySelector(insertBeforeSelector)
            : null;
          const destinationPrice =
            destinationMainContent.querySelector(".price-wrapper");

          sourceNodes.forEach((sourceNode) => {
            const clonedNode = sourceNode.cloneNode(true);

            if (preferredInsertBefore) {
              destinationMainContent.insertBefore(
                clonedNode,
                preferredInsertBefore
              );
            } else if (destinationPrice) {
              destinationMainContent.insertBefore(clonedNode, destinationPrice);
            } else {
              destinationMainContent.appendChild(clonedNode);
            }
          });
        }

        return;
      }

      sourceNodes.forEach((sourceNode, index) => {
        const destinationNode = destinationNodes[index];
        if (destinationNode) {
          destinationNode.innerHTML = sourceNode.innerHTML;
          destinationNode.className = sourceNode.className;
        }
      });

      // Remove stale extra destination nodes when source has fewer nodes.
      if (destinationNodes.length > sourceNodes.length) {
        destinationNodes.forEach((destinationNode, index) => {
          if (index >= sourceNodes.length) {
            destinationNode.remove();
          }
        });
      }
    };

    if (sourceInfoContainers.length && destinationInfoContainers.length) {
      destinationInfoContainers.forEach((destinationInfoContainer, index) => {
        const sourceInfoContainer =
          sourceInfoContainersArray.find(
            (sourceContainer) =>
              sourceContainer.className === destinationInfoContainer.className
          ) || sourceInfoContainers[index];

        if (!sourceInfoContainer) return;

        if (!isQuickView) {
          syncInfoSelector(
            sourceInfoContainer,
            destinationInfoContainer,
            ".product__custom-badges",
            ".product__title__wrapper"
          );
        }
        syncInfoSelector(
          sourceInfoContainer,
          destinationInfoContainer,
          ".product__tags",
          ".product__title__wrapper"
        );
        syncInfoSelector(
          sourceInfoContainer,
          destinationInfoContainer,
          ".about__accordion-description"
        );
      });
    }

    syncQuickViewCustomBadgesInTitle();
    removeQuickViewRedundantCustomBadges();

    // sticky add-to-cart title and image
    const sourceStickyForm = html.getElementById(
      `sticky-bar-product-form-${sourceSectionId}`
    );
    const destinationStickyForm = this.getScopedElementById(
      destinationScope,
      `sticky-bar-product-form-${currentSectionId}`
    );
    const sourceStickyBar = sourceStickyForm?.closest(
      ".product-sticky-add-bar"
    );
    const destinationStickyBar = destinationStickyForm?.closest(
      ".product-sticky-add-bar"
    );

    if (sourceStickyBar && destinationStickyBar) {
      const sourceStickyTitle = sourceStickyBar.querySelector(
        ".product-sticky-add-bar__title"
      );
      const destinationStickyTitle = destinationStickyBar.querySelector(
        ".product-sticky-add-bar__title"
      );
      if (sourceStickyTitle && destinationStickyTitle) {
        destinationStickyTitle.innerHTML = sourceStickyTitle.innerHTML;
      }

      const sourceStickyMedia = sourceStickyBar.querySelector(
        ".product_info .media"
      );
      const destinationStickyMedia = destinationStickyBar.querySelector(
        ".product_info .media"
      );
      if (sourceStickyMedia && destinationStickyMedia) {
        destinationStickyMedia.innerHTML = sourceStickyMedia.innerHTML;
      }
    }

    // price
    const priceDestination = this.getScopedElementById(
      destinationScope,
      `price-${currentSectionId}`
    );
    const priceStickyDestination = this.getScopedElementById(
      destinationScope,
      `price-sticky-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    const sourceStickyPrice = sourceStickyBar?.querySelector(
      `#price-sticky-${sourceSectionId}`
    );
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    const stickyPriceSource = sourceStickyPrice || priceSource;
    if (stickyPriceSource && priceStickyDestination) {
      priceStickyDestination.innerHTML = stickyPriceSource.innerHTML;
      priceStickyDestination.classList.remove("visibility-hidden");
      const priceText = priceStickyDestination.querySelector(".price-text");
      if (priceText) priceText.className = "price-text";
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = this.getScopedElementById(
      destinationScope,
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    const pickerInventorySource = html.getElementById(
      `PickerInventory-${sourceSectionId}`
    );
    const pickerInventoryDestination = this.getScopedElementById(
      destinationScope,
      `PickerInventory-${currentSectionId}`
    );
    if (pickerInventorySource && pickerInventoryDestination) {
      pickerInventoryDestination.innerHTML = pickerInventorySource.innerHTML;
      pickerInventoryDestination.classList.toggle(
        "visibility-hidden",
        pickerInventorySource.innerText === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = this.getScopedElementById(
      destinationScope,
      `Sku-${currentSectionId}`
    );
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = destinationScope.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const sourcePicker = this.getVariantPickerElement(html, sourceSectionId);
      const destinationPicker = this.getVariantPickerElement(
        destinationScope,
        currentSectionId
      );
      const variantSwatchesSource = sourcePicker?.querySelector(
        '[data-is-variant-image-swatch="true"]'
      );
      const variantSwatchesDestination = destinationPicker?.querySelector(
        '[data-is-variant-image-swatch="true"]'
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-add-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML = this.remapMarkupToSection(
            variantSwatchesSource.innerHTML,
            sourceSectionId,
            currentSectionId
          );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      const scopedMediaDestination = destinationScope.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      if (mediaSource && scopedMediaDestination) {
        // 1. SAFELY CLEAN UP MEMORY FOR PREVIOUS SWIPER INSTANCES BEFORE OVERWRITING HTML
        const oldMainSwiper =
          scopedMediaDestination.querySelector(".js-media-list")?.swiper;
        const oldSubSwiper =
          scopedMediaDestination.querySelector(".js-media-sublist")?.swiper;

        if (oldMainSwiper) oldMainSwiper.destroy(true, true);
        if (oldSubSwiper) oldSubSwiper.destroy(true, true);

        // 2. DROP IN NEW MARKUP
        scopedMediaDestination.innerHTML = mediaSource.innerHTML;

        const section = this.getScopedElementById(
          destinationScope,
          `shopify-section-${currentSectionId}`
        );

        if (isQuickView) {
          if (typeof quickAddsliderInit === "function") {
            quickAddsliderInit(true, destinationScope);
          }
        } else {
          if (typeof subSliderInit === "function") {
            subSliderInit(true, scopedMediaDestination);
          }
          if (typeof sliderInit === "function") {
            sliderInit(true, scopedMediaDestination);
          }
        }
        if (!isQuickView && section && typeof initProductPage === "function") {
          initProductPage(section);
        }
      }

      // Product modal sync
      const modalSource = html.getElementById(
        `ProductModal-${sourceSectionId}`
      );
      const modalDestination = this.getScopedElementById(
        destinationScope,
        `ProductModal-${currentSectionId}`
      );
      if (modalSource && modalDestination) {
        modalDestination.innerHTML = modalSource.innerHTML;

        const modalCloseButton = modalDestination.querySelector(
          '[id^="ModalClose-"]'
        );
        if (modalCloseButton) {
          modalCloseButton.addEventListener("click", () => {
            if (typeof modalDestination.hide === "function") {
              modalDestination.hide();
            }
          });
        }

        if (typeof popupSubSliderInit === "function") {
          popupSubSliderInit(true);
        }
        if (typeof popupSliderInit === "function") {
          popupSliderInit(true);
        }
      }
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition || 0) -
        Number(b.dataset.optionPosition || 0)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = this.getVariantPickerElement(
      html,
      sourceSectionId
    );
    const variantPickerDestination = this.getVariantPickerElement(
      this.getUpdateScope(),
      this.dataset.section
    );
    if (!variantPickerSource || !variantPickerDestination) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestination.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = this.getVariantPickerElement(
      html,
      sourceSectionId
    );
    const variantPickerDestination = this.getVariantPickerElement(
      this.getUpdateScope(),
      currentSectionId
    );

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-add-modal");
      if (quickViewModal) {
        variantPickerDestination.innerHTML = this.remapMarkupToSection(
          variantPickerSource.innerHTML,
          sourceSectionId,
          currentSectionId
        );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }

      this.reinitializeDropdownSelect();
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const options = [];

    fieldsets.forEach((fieldset, index) => {
      const checkedInput = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked);
      if (!checkedInput) return;

      const position =
        Number(fieldset.dataset.optionPosition) || index + 1;
      options[position - 1] = checkedInput.value;
    });

    this.options = options;
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector("form")) {
      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    } else {
      this.querySelector("[name=id]").disabled = false;
      this.querySelector("button[type=submit]").addEventListener(
        "click",
        this.onSubmitHandler.bind(this)
      );
    }
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector("cart-drawer"))
      this.submitButton.setAttribute("aria-haspopup", "dialog");

    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (!this.form) {
      formData.append("id", this.querySelector("[name=id]").value);
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner")?.classList.add(
          "hidden"
        );
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");

    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen =
        el.querySelector(".icon-eye-close") !== null
          ? el.querySelector(".icon-eye-close")
          : el.querySelector(".pass-hide");
      const btnClose =
        el.querySelector(".icon-eye") !== null
          ? el.querySelector(".icon-eye")
          : el.querySelector(".pass-show");

      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });

      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });

      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsSlider = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this.initProductRecommendations();
  }

  initProductRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.checkSlider();
        this.initComplementarySlider();
        if (this.dataset.on_hover_slider) {
          initSlider();
        }
        if (this.dataset.fade_scroll) {
          fadeScrollEffect();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this._initialized = true;
      });
  }

  initSlider() {
    const sliderEl = this.querySelector(".product-recommendations-slider");
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const nextBtn = this.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = this.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = this.querySelector(".heading-group__pagination");
    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
      spaceBetween: 4,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
        },
      },
    };
    this.recommendationsSlider = new Swiper(sliderEl, sliderSettings);
  }

  initComplementarySlider() {
    document
      .querySelectorAll(".complementary-products-js")
      .forEach((elem, index) => {
        let mobileLayout = 1;
        if (elem.dataset.mobileLayout) {
          mobileLayout = elem.dataset.mobileLayout;
        }
        let slider = new Swiper(
          elem.querySelector(".js-recommendation-swiper"),
          {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 4,
            speed: 600,
            allowTouchMove: true,
            mousewheel: {
              forceToAxis: true,
            },
            navigation: {
              nextEl: elem.querySelector(
                ".heading-group__navigation-button-next"
              ),
              prevEl: elem.querySelector(
                ".heading-group__navigation-button-prev"
              ),
              disabledClass: "swiper-button-disabled",
            },
            pagination: {
              el: elem.querySelector(".heading-group__pagination"),
              type: "fraction",
            },
            breakpoints: {
              576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 8,
              },
              990: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 4,
              },
            },
          }
        );
      });
  }

  destroySlider() {
    if (this.recommendationsSlider) {
      this.recommendationsSlider.destroy();
      this.recommendationsSlider = null;
    }
  }

  checkSlider() {
    const layout = this.dataset.layout || "grid";

    if (layout === "slider") {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

(function () {
  const initHeaderOverlay = () => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        ".section--has-overlay"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );
      const header = document.querySelector(".shopify-section-header");

      if (sectionFirstChild) {
        if (sectionFirstChild.classList.contains("section--has-overlay")) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove("not-margin");
            header.classList.add("color-background-1", "color-background-3");
          } else {
            sections[0].classList.add("not-margin");
            header.classList.remove("color-background-1", "color-background-3");
          }
        } else {
          sections[0].classList.remove("not-margin");
          header.classList.remove("color-background-1", "color-background-3");
        }
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener("shopify:section:load", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:unload", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:reorder", function () {
    initHeaderOverlay();
  });
})();

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  cents = parseInt(cents, 10);
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = precision > 0 ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector(".disclosure__button-modal"),
      panel: this.querySelector("ul"),
      buttonSpan: this.querySelector(".disclosure__button-modal span"),
    };

    const targetElement = this.elements.button;
    const excludeElement = this.elements.panel;

    this.elements.button?.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );

    this.handleClickOutside(targetElement, excludeElement);
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    if (!this.elements.panel.classList.contains("disclosure__list-modal")) {
      this.elements.panel.setAttribute("hidden", true);
    }
  }

  handleClickOutside(target, exclude) {
    document.addEventListener("click", (event) => {
      if (
        !target.contains(event.target) &&
        (!exclude || !exclude.contains(event.target))
      ) {
        this.hidePanel();
      }
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
    document.body.classList.add("region-open");
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

(function () {
  const selectDropDown = (scope = document) => {
    const $scope = scope === document ? $(document) : $(scope);

    $scope.find(".product-form__controls--dropdown").each(function () {
      const elListItem = $(this).find(".dropdown-select ul li");
      const elItem = $(this).find(".dropdown-select ul");
      const selectedText = $(this).find(".dropdown-select .select-label");

      selectedText
        .off("click.variantDropdown")
        .on("click.variantDropdown", function (e) {
          const isActive = elItem.hasClass("active");
          $scope.find(".dropdown-select ul").removeClass("active");

          if (!isActive) {
            elItem.addClass("active");
            e.stopPropagation();
          }
        });

      elListItem
        .off("click.variantDropdown")
        .on("click.variantDropdown", function () {
          if (
            $(this).find("input").hasClass("disabled") == false ||
            $(this).find("label").hasClass("notify_me")
          ) {
            selectedText
              .find("span")
              .text($(this).text())
              .attr("title", $(this).text());
          }

          elItem.removeClass("active");
          document.activeElement.blur();
        });
    });

    if (scope === document) {
      $(document)
        .off("click.dropdown")
        .on("click.dropdown", function () {
          $(".dropdown-select ul").removeClass("active");
        });
    }
  };

  window.initProductDropdownSelect = selectDropDown;

  document.addEventListener("DOMContentLoaded", function () {
    selectDropDown();
    document.addEventListener("shopify:section:load", function () {
      selectDropDown();
    });
  });
})();
